module.exports = __webpack_public_path__ + "static/media/Southgrove Kitchen Sink.667a65ca.JPG";